import { ref } from "@nuxtjs/composition-api";
import useFetchDocuments from "./useFetchDocuments";
import useFetchFaqs from "./useFetchFaqs";
import useFetchProducts from "./useFetchProducts";
const NO_RICH_TYPES = ["short_description", "tags", "category-recommended"];
function useProductPage() {
  const { fetchProductBySlug } = useFetchProducts();
  const { faqs, fetchFaqs } = useFetchFaqs();
  const { documents, fetchDocuments, DOCUMENT_TYPES } = useFetchDocuments();
  const product = ref();
  const productContent = ref();
  const fetchProduct = async (params) => {
    try {
      const { slug, ...queryParams } = params;
      const data = await fetchProductBySlug(slug, queryParams);
      if (!data)
        return;
      await fetchFaqs(data.id);
      await fetchDocuments(
        { product_sku: data.sku },
        {
          videos: [DOCUMENT_TYPES.VIDEOS],
          manuals: {
            exclude: [DOCUMENT_TYPES.SOFTWARE]
          }
        }
      );
      data.faqs = faqs.value;
      data.documents = documents.value;
      productContent.value = data.content?.filter(
        ({ type }) => !NO_RICH_TYPES.includes(type)
      );
      product.value = data;
    } catch (e) {
      console.error("Fetch failed: ", e);
    }
  };
  return {
    product,
    productContent,
    fetchProduct
  };
}
var useProductPage_default = useProductPage;
export {
  useProductPage_default as default
};
